import styled from '@emotion/styled';
import { ErrorMessages } from '../../../utils/errorMessages';
import { Css, ITheme, Responsive } from '../../../ui';
import { Color } from '../../../styles/Color';
import ErrorIcon from '../../../assets/icons/error/error.svg';
import RefreshIcon from '../../../assets/icons/error/refresh.svg';
import Button from '../button/Button';

interface INoResultsProps {
	icon?: JSX.Element;
	title?: string;
	message?: string;
	className?: string;
}

export const ErrorState = ({
	icon,
	title,
	message,
	className,
}: INoResultsProps) => {
	const refreshPage = () => window.location.reload();
	return (
		<Wrapper className={className}>
			<IconWrapper>
				{icon ?? <ErrorIcon role="presentation" width={40} height={40} />}
			</IconWrapper>
			<Title>{title ?? 'Error'}</Title>
			<Message>{message || ErrorMessages.GenericError}</Message>
			<Button
				onClick={refreshPage}
				buttonType="outlined"
				icon={<RefreshIcon />}
			>
				Refresh
			</Button>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	padding: ${Css.pxToRem(80)} 0;
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: 250px;
	text-align: center;
	margin: 0 auto;
	flex-direction: column;
`;

const IconWrapper = styled.div`
	margin-bottom: ${Css.pxToRem(20)};
`;

const Title = styled.h4<{}, ITheme>`
	color: ${Color.OnBackgroundText2};
	margin-bottom: ${Css.pxToRem(12)};
	line-height: ${Css.pxToRem(38)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		line-height: ${Css.pxToRem(28)};
	}
`;

const Message = styled.p`
	color: ${Color.PrimaryBlue};
	margin-bottom: ${Css.pxToRem(24)};
`;
